import type { BillingSignedDocument } from "../../shared/billing-document-schemas";
import { termsFromDocument } from "../../shared/billing-document-terms";
import type { BillingTool } from "../../shared/billing-schemas";
import type { QuoteSource } from "./billing-quote-draft";

/**
 * The terms form's starting values for a signed document (ADR-0073), for the documents a person
 * reviews before billing: change orders, and order forms that could not be added on their own.
 */
export function documentSource(document: BillingSignedDocument, tools: BillingTool[]): QuoteSource {
  const { terms } = termsFromDocument(document, tools);
  return {
    title: terms.title,
    tool: tools.find((tool) => tool.id === terms.toolId) ?? null,
    effectiveAt: terms.effectiveAt,
    endsAt: terms.endsAt,
    notes: terms.notes,
    discount: terms.discount,
    lines: terms.lines.map((line, position) => ({
      ...line,
      id: `bline_document_${String(position)}`,
      position,
      totalMinor: line.unitAmountMinor * line.quantity,
    })),
  };
}
